(() => {
  const configuration = () => document.querySelector('[data-sm-offer-config]');
  const active = () => {
    const config = configuration();
    if (!config || config.dataset.smEnabled !== 'true') return false;
    const now = Date.now();
    return now >= Date.parse(config.dataset.smStart) && now < Date.parse(config.dataset.smEnd);
  };
  const unitPrice = regular => active() ? Math.round(regular * 5499 / 7999) : regular;
  // Pack reductions apply to the subtotal after the launch product discount.
  const total = (regular, quantity) => {
    if (!active()) return regular * quantity;
    const subtotal = unitPrice(regular) * quantity;
    const discount = quantity >= 3 ? 0.3 : quantity >= 2 ? 0.2001 : 0;
    return subtotal - Math.floor(subtotal * discount);
  };
  window.SnugMagOffer = { active, unitPrice, total };
  let previous;
  const tick = () => {
    const config = configuration();
    if (!config) return;
    const isActive = active();
    const currency = config.dataset.smCurrency || 'GBP';
    const format = cents => new Intl.NumberFormat('en-GB', { style: 'currency', currency }).format(cents / 100);
    document.querySelectorAll('[data-sm-offer-price]').forEach(element => {
      const regular = Number(element.dataset.smRegularCents);
      if (Number.isFinite(regular)) element.textContent = format(unitPrice(regular));
    });
    document.querySelectorAll('[data-sm-offer-only],[data-sm-offer-banner]').forEach(element => element.hidden = !isActive);
    document.querySelectorAll('[data-sm-offer-fallback]').forEach(element => element.hidden = isActive);
    const remaining = Math.max(0, Math.ceil((Date.parse(config.dataset.smEnd) - Date.now()) / 1000));
    const parts = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60 };
    document.querySelectorAll('[data-sm-countdown]').forEach(timer => {
      timer.querySelectorAll('[data-sm-time]').forEach(element => {
        element.textContent = String(parts[element.dataset.smTime] || 0).padStart(2, '0');
      });
    });
    if (previous !== isActive) {
      previous = isActive;
      document.dispatchEvent(new CustomEvent('snugmag:offer-change'));
    }
  };
  document.addEventListener('DOMContentLoaded', tick);
  document.addEventListener('shopify:section:load', () => { previous = undefined; tick(); });
  document.addEventListener('visibilitychange', tick);
  setInterval(tick, 1000);
})();
